import { Injectable } from '@angular/core';

/**
 * Whether this page is the embedded editor (`/embed/…`) and, once its one-time code has been
 * exchanged, the token of its editing session. It lives at the root because the two things that
 * must behave differently there are root things: the app initializer (no Keycloak login: the
 * person has no Templatify user) and the HTTP interceptor (the session token instead of a
 * bearer, and no panel toasts or logout on errors).
 */
@Injectable({ providedIn: 'root' })
export class EmbedSessionState {
  /** True for the whole life of the page: an embedded editor never becomes the panel. */
  readonly active = EmbedSessionState.isEmbedPath(window.location.pathname);

  /** In memory only. It dies with the page, which is the point. */
  token: string | null = null;

  static isEmbedPath(pathname: string): boolean {
    return /^\/embed(\/|$)/.test(pathname || '');
  }
}
